module.exports = __webpack_public_path__ + "img/code.6d722ca4.jpg";